import { render, staticRenderFns } from "./ProductAttributesMobile.vue?vue&type=template&id=0a5444f5&"
import script from "./ProductAttributesMobile.vue?vue&type=script&lang=js&"
export * from "./ProductAttributesMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports